import * as React from "react";
import { Field as FormikField, FieldAttributes, FieldProps, useFormikContext } from "formik";

export default function SemanticField({ component, name, deps, optionsSource, children, options, ...fieldProps }: FieldAttributes<any>) {
    const [data, setData] = React.useState<any>([]);
    const formixctx = useFormikContext()

    React.useEffect(() => {
        if (optionsSource) {
            const promiseLike = optionsSource();
            // console.log(optionsSource);
            if ('then' in promiseLike)
                Promise.resolve(promiseLike).then(result => {
                    setData(result)
                    // console.log(formixctx.values);

                    // console.log(result)
                    // if (result && result.length)
                    //     formixctx.setFieldValue(name, result[0].value);
                });
        }
    }, [optionsSource, formixctx.values, ...(deps?.map(dep => formixctx.values[dep]) ?? [])])

    return (
        <FormikField
            name={name}
            {...fieldProps}>
            {({ field: { value, onBlur: _onBlur, onChange: _onChange, ...field }, form: { setFieldValue, setFieldTouched, handleBlur, handleReset, handleChange }, meta, ...props }: FieldProps) =>
                React.createElement(component, {
                    name: name,
                    ...fieldProps,
                    ...field,
                    // ...props,
                    ...(typeof value === "boolean"
                        ? {
                            checked: value ?? false,
                        }
                        : {
                            value: value != null ? value : "",
                        }),
                    onBlur: async (e) => {
                        await setFieldTouched(name)
                        handleBlur(name);
                    },
                    onChange: async (e, data) => {
                        // console.log(e)
                        // console.log(`changed: e: ${e}, data: ${data}`)
                        const newValue = data != null ? data.value : e;
                        const checked = data != null ? data.checked : e;
                        await setFieldTouched(name);
                        await setFieldValue(name, newValue != null ? newValue : checked ?? false);

                        handleChange(name);

                        if (fieldProps.onChange)
                            fieldProps.onChange(e, newValue);

                    },
                    error: (meta.touched && meta.error != null) ? meta.error : undefined,
                    options: optionsSource ? data : options
                }, children)

            }

        </FormikField>
    );
}
